// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { showSnackBar } from "../../snackbar/actions"
import {
  ListFavouriteTimesheetFieldOptionsResponse,
  ReorderFavouriteTimesheetFieldOptionRequestSchema,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"
import { from, Init, timesheetFieldService } from "../../../app/rpc"
import { create } from "@bufbuild/protobuf"

type ReorderFavouriteTimesheetFieldOptionRpc = (request: Init<typeof ReorderFavouriteTimesheetFieldOptionRequestSchema>) => Observable<ListFavouriteTimesheetFieldOptionsResponse>

export const reorderFavouriteTimesheetFieldOption = (reorderFavouriteTimesheetFieldOptionRpc: ReorderFavouriteTimesheetFieldOptionRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.reorderFavouriteTimesheetFieldOption.match),
      mergeMap((action) => reorderFavouriteTimesheetFieldOptionRpc(action.payload)
        .pipe(
          map(response => ({
            siteId: action.payload.siteId ?? "",
            options: response.timesheetFieldOptions,
          })),
          map(Slice.setFavouriteTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_reorder_favourite_timesheet_field_option_failed",
              message: "Failed to reorder timesheet field option. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const reorderFavouriteTimesheetFieldOptionRpc = (request: Init<typeof ReorderFavouriteTimesheetFieldOptionRequestSchema>): Observable<ListFavouriteTimesheetFieldOptionsResponse> =>
  from(() => timesheetFieldService.reorderFavouriteTimesheetFieldOption(create(ReorderFavouriteTimesheetFieldOptionRequestSchema, request)))

export default reorderFavouriteTimesheetFieldOption(reorderFavouriteTimesheetFieldOptionRpc)
